<script lang="ts" setup>
import { siteName, logo } from '~~/content/settings/settings.json'

const { navigation } = defineProps<{ navigation?: { text: string, to: string, parent?: string }[] }>()
const closed = ref(true)
const route = useRoute()

watch(() => route.fullPath, (val) => {
  closed.value = true
})

const finalNavigation = computed(() => {
  const [withParent, withoutParent] = navigation.reduce(
    ([yes, no], item) => {
      if (item.parent !== undefined) {
        yes.push(item)
      }
      else {
        no.push(item)
      }
      return [yes, no]
    },
    [[], []],
  )
  return withoutParent.map((item) => {
    const children = withParent.filter(child => child.parent === item.text)
    if (children.length) {
      return { ...item, children }
    }
    return item
  })
})
</script>

<template>
  <div class="w-full px-3 xl:px-8  bg-zinc-100 flex justify-between fixed top-0 z-50">
    <NuxtLink to="/" class="w-40 md:w-48 h-auto py-4 flex items-center justify-center xl:w-56">
      <img :src="logo" class="h-auto w-full">
    </NuxtLink>
    <button class="hover:text-primary cursor-pointer 2xl:hidden z-50 relative py-2" @click="closed = !closed">
      <Icon name="mdi:menu" class="text-3xl" />
    </button>
    <ul
      class="px-12 2xl:px-3 xl:px-6 duration-500 gap-3 md:gap-6 2xl:gap-6 flex flex-col items-start  fixed top-0 left-0 2xl:translate-x-0 h-screen 2xl:h-auto w-screen 2xl:w-auto uppercase font-semibold tracking-wider 2xl:flex 2xl:flex-row 2xl:relative justify-center 2xl:items-center"
      :class="[closed ? 'translate-x-[150%]' : '  bg-zinc-100 z-50 translate-x-0 ']">
      <button class="hover:text-primary cursor-pointer 2xl:hidden absolute top-6 right-12" @click="closed = true">
        <Icon name="mdi:close" class="text-2xl" />
      </button>
      <li v-for="link in finalNavigation" :key="link.to"
        class="group text-zinc-600 hover:text-zinc-800 flex-nowrap  w-auto inline-block hover:after:w-full after:duration-300 relative 2xl:py-6">
        <NuxtLink v-if="!link.children" :to="getPage({ to: link.to })"
          class="py-2 after:absolute after:w-0 w-auto inline-block  px-1 relative after:-bottom-1 after:right-0 group-hover:after:bg-primary after:z-[-1] group-hover:after:w-full after:duration-300 after:h-[2px]"
          active-class="group-hover:after:bg-primary-dark text-zinc-800">
          {{ link.text }}
        </NuxtLink>
        <template v-else>
          <a
            class="flex flex-col text-left 2xl:cursor-pointer py-2 after:absolute after:w-0 w-auto 2xl:inline-block group-hover:after:w-full after:duration-300 2xl:after:h-[2px] px-1 relative after:-bottom-1 after:right-0 group-hover:after:bg-primary after:z-[-1]">{{
              link.text }}</a>
          <ul
            class="flex-col 2xl:absolute 2xl:top-18 2xl:bg-zinc-100 2xl:rounded-2xl 2xl:overflow-clip 2xl:shadow-lg 2xl:hidden 2xl:group-hover:block 2xl:hover:block">
            <li v-for="sublink in link.children" :key="sublink.to"
              class="whitespace-nowrap 2xl:hover:bg-zinc-200 group/list">
              <NuxtLink :to="getPage({ to: sublink.to })"
                class="relative block px-4 py-2  after:absolute  after:w-0  after:-bottom-0 after:right-0 group-hover/list:after:bg-primary after:z-[-1] group-hover/list:after:w-full after:duration-300 after:h-[2px]"
                active-class="font-bold text-primary">
                {{ sublink.text }}
              </NuxtLink>
            </li>
          </ul>
        </template>
      </li>
      <ShoppingCartNav />
      <UserAccountNav />
    </ul>
  </div>
</template>
